import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { palette as T, type } from '../design';

export function VerifyEmailPage({ setPage }) {
  const { verifyEmail } = useAuth();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');
  // The verify token is single-use: the backend nulls it on success. This effect must
  // fire exactly once — otherwise a re-render (verifyEmail identity churns when the
  // AuthProvider re-renders) or StrictMode fires it twice, the first call verifies and
  // the second hits an already-consumed token, showing a false "expired" failure.
  const started = useRef(false);


  useEffect(() => {
    if (started.current) return;
    started.current = true;
    // The verify link is hash-routed (#/verify-email?token=...), so the token is in the
    // hash, not window.location.search.
    const hash = window.location.hash;
    const q = hash.indexOf('?');
    const token = q !== -1 ? new URLSearchParams(hash.slice(q + 1)).get('token') : null;
    if (!token) {
      setStatus('error');
      setMessage('This verification link is incomplete. Please open the link in your email again, or request a new one.');
      return;
    }
    verifyEmail(token)
      .then(() => {
        setStatus('success');
        setMessage('Your email is verified. You can now log in.');
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.message || 'This verification link is invalid, expired, or has already been used. If you have already verified your email, just log in.');
      });
  }, [verifyEmail]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '80px 20px 40px', background: T.ivory }}>
      <div style={{ width: '100%', maxWidth: 420, background: T.white, borderRadius: 20, border: '1px solid ' + T.border, padding: '32px 28px', textAlign: 'center' }}>
        {status === 'verifying' && (
          <>
            <h1 style={{ fontFamily: "'Lora', serif", fontWeight: 700, fontSize: 24, color: T.espresso, margin: '0 0 12px' }}>Verifying your email…</h1>
            <p style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 15, color: T.walnut }}>Please wait a moment.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <h1 style={{ fontFamily: "'Lora', serif", fontWeight: 700, fontSize: 24, color: T.sageGreen, margin: '0 0 12px' }}>Email Verified</h1>
            <p style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 15, color: T.walnut, marginBottom: 24 }}>{message}</p>
            <button
              onClick={() => setPage('login')}
              style={{ background: T.terracotta, color: T.white, border: 'none', borderRadius: 12, padding: '12px 24px', fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 600, fontSize: type.body, cursor: 'pointer' }}
            >
              Go to Login
            </button>
          </>
        )}
        {status === 'error' && (
          <>
            <h1 style={{ fontFamily: "'Lora', serif", fontWeight: 700, fontSize: 24, color: T.errorRed, margin: '0 0 12px' }}>Verification Failed</h1>
            <p style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 15, color: T.walnut, marginBottom: 24 }}>{message}</p>
            <button
              onClick={() => setPage('login')}
              style={{ background: T.terracotta, color: T.white, border: 'none', borderRadius: 12, padding: '12px 24px', fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 600, fontSize: type.body, cursor: 'pointer' }}
            >
              Go to Login
            </button>
            <div style={{ marginTop: 16 }}>
              <button
                onClick={() => setPage('home')}
                style={{ background: 'none', border: 'none', cursor: 'pointer', fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: type.body, color: T.walnut }}
              >
                ← Back to home
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
